document.addEventListener("DOMContentLoaded", function () {
  if ($('#banners').length > 0) {
    let amountImg = translations.count_banners;
    if (amountImg > 0) {
      let widthImg = 728;
      let waitTime = 8000;


      let deltaX = 0;
      let slider = document.getElementById('banners');

      window.setInterval(doSlide, waitTime);

      function doSlide() {
        deltaX += widthImg;
        deltaX %= amountImg*widthImg;
        slider.querySelector('.slideshow-banners').style.marginLeft = '-' + deltaX + 'px';
      }
    }
  }
});